import Label from "./Label";
import { Editor as QuillEditor } from "primereact/editor";

const Editor = ({
  readOnly = false,
  disabled = false,
  label,
  required = false,
  input,
}) => {
  const renderHeader = () => {
    return (
      <>
        <span className="ql-formats">
          <select class="ql-size">
            <option value="small"></option>
            <option selected></option>
            <option value="large"></option>
            <option value="huge"></option>
          </select>
        </span>
        <span className="ql-formats">
          <button className="ql-bold" aria-label="Bold"></button>
          <button className="ql-italic" aria-label="Italic"></button>
          <button className="ql-underline" aria-label="Underline"></button>
          <button className="ql-strike" aria-label="Strike"></button>
          <button className="ql-blockquote" aria-label="BlockQuote"></button>
          <button className="ql-code-block" aria-label="Code-Block"></button>
          <button className="ql-link" aria-label="Link"></button>
        </span>
        <span className="ql-formats">
          <button className="ql-list" value="ordered" type="button"></button>
          <button className="ql-list" value="bullet" type="button"></button>
        </span>
        <span className="ql-formats">
          <select class="ql-align">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
          </select>
        </span>
      </>
    );
  };

  const header = renderHeader();

  return (
    <div
      className={`edexlms-field text-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <QuillEditor
        {...input}
        headerTemplate={header}
        onTextChange={(e) => input.onChange(e.htmlValue)}
        readOnly={readOnly}
        style={{ height: "320px" }}
      />
    </div>
  );
};

export default Editor;
